import { Button } from "reactstrap";
import { Modal } from "react-bootstrap";
import React from "react";
import Select from "react-select";
import { columnsCsv } from "./registrationaldetails/content";
import { getManageuserdata } from "./manageuserVerification/mockdata";
import Loading from "../loader/loader";

const ChangePasswordConfirmation = (props) => {
  console.log("props", props);
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to reset this user's password?
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-primary"
          color="primary"
          onClick={() => props.onPasswordChange()}
        >
          {props.passwordResetLoader ? (
            <Loading color="white" width="15px" height="15px" />
          ) : (
            "Yes"
          )}
        </Button>
        <Button
          variant="outline-primary"
          color="primary"
          onClick={() => props.onHide()}
        >
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangePasswordConfirmation;
